import { Section, Row, Col } from 'components/grid'
import React from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { graphql, useStaticQuery } from 'gatsby'
import { ToolkitQueryEdge } from 'pages/intervention'
import ToolkitTabs from 'components/intervention/ToolkitTabs'
import SectionTitle from 'components/global/SectionTitle'

export default function SecondaryToolkits({ ...props }) {
	const data = useStaticQuery<ToolkitQuery>(query)

	const { secondary } = data

	return (
		<Section id={formatSectionId(props)} className="mt-20 scroll-mt-14">
			<SectionTitle
				title="IRLA Toolkits for Secondary Grades"
				text="Conceptually linked lessons build knowledge and reading skills. Age-appropriate, high-interest texts engage students in meaningful practice that builds confidence."
			/>

			<Row>
				<Col>
					<ToolkitTabs showFrameworks toolkits={secondary} />
				</Col>
			</Row>
		</Section>
	)
}

interface ToolkitQuery {
	secondary: ToolkitQueryEdge
}

const query = graphql`
	query {
		secondary: allContentfulToolkit(filter: { type: { eq: "Secondary" } }) {
			edges {
				node {
					...toolkit
				}
			}
		}
	}
`
